import { resolvedEventBookingType, TDR } from 'tdr-common';
import { resolveEventBookNowGroupSize } from './resolveEventBookNowGroupSize';

export function buildEventBookNowUrl(
	event: TDR.Event,
	restaurantSlug: string,
	tables: TDR.Table[],
	resolvedDate: string | null,
	resolvedTime: string | null
): string | undefined {
	const evKind = resolvedEventBookingType(event);

	// Table events open the linked table with no pre-filled params so guests
	// can choose their own date / time / party size.
	if (evKind === 'table' && event.linkedTableSlug) {
		return `/${restaurantSlug}/explore/${event.linkedTableSlug}`;
	}

	if (evKind === 'param') {
		if (!resolvedDate) {
			return undefined;
		}

		const groupSize = resolveEventBookNowGroupSize(event, tables);

		const params = new URLSearchParams({
			groupSize: String(groupSize),
			date: resolvedDate
		});
		if (resolvedTime) {
			params.set('time', resolvedTime);
		}
		return `/${restaurantSlug}/explore/filters?${params.toString()}`;
	}

	return undefined;
}
